import ImportWalletTemp from "../templates/ImportWalletTemp";

const ImportWallet = () => <ImportWalletTemp />;

export default ImportWallet;